import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormSingleChoiceBlock as Block } from "./FormSingleChoiceBlock";
import { defaultData } from "./FormSingleChoiceBlockDefaultData";
import { meta } from "./FormSingleChoiceBlockMetaData";

export const FormSingleChoiceBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-single-choice",
    size: 24,
  },
  meta,
};
